module.exports = "https://www.gc-qa.gnp.com.mx/c4f2143da901d61a6c77cfd8bc86f3ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-close.png
// module id = 971
// module chunks = 0